enum AlarmRaiseOption {
	DefaultIgnore = 0,
	DefaultAutoHandle = 1,
	NotSet = 2,
}

export default AlarmRaiseOption;
